import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';

const useStyles = makeStyles()((theme) => ({
  button: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  }
}));

type Props = {
  onClick?: (...args: unknown[]) => void;
  loading?: boolean;
  link?: string;
};

const LoadMore = ({ onClick, loading, link }: Props) => {
  const { classes } = useStyles();

  return (
    <Button
      href={link}
      data-prevent-progress="true"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      className={classes.button}
      variant="outlined"
      color="primary"
      disabled={loading}
    >
      {loading ? 'Loading...' : 'Load More'}
    </Button>
  );
};

export default LoadMore;
